export default __webpack_public_path__ + "media/b15c888060afea03ca57287d5058b6d46b5cfb845e9aec6ebc4d3607433691b9.svg";